import { TFunction } from "i18next";
import { UserManagementRow } from "../typings/user-management.type";
import {
  validateBooleanRequired,
  validateRequired
} from "../../../../components/EquipmentList/equipmentlist.functions";

export function validateUserManagementRow(
  row: Partial<UserManagementRow>,
  rowOriginal: UserManagementRow,
  t: TFunction
) {
  // check whether row original has the value already, to prohibit return error when user want to maintain the existing data
  const firstNameReq = row.firstName || rowOriginal.firstName;
  const surnameReq = row.surname || rowOriginal.surname;
  const emailReq = row.email || rowOriginal.email;
  const supervisorInfoReq = row.supervisorInfo || rowOriginal.supervisorInfo;
  const companyIdReq = row.companyId || rowOriginal.companyId;
  const isActiveReq = row.isActive || rowOriginal.isActive;

  return {
    firstName: validateRequired(firstNameReq) ? "" : t("First name cannot be empty"),
    surname: validateRequired(surnameReq) ? "" : t("Last name cannot be empty"),
    email: validateRequired(emailReq) ? "" : t("Email cannot be empty"),
    supervisorInfo: validateRequired(supervisorInfoReq) ? "" : t("Supervisor cannot be empty"),
    companyId: validateRequired(companyIdReq?.toString()) ? "" : t("Company cannot be empty"),
    isActive: validateBooleanRequired(isActiveReq) ? "" : t("Status cannot be empty")
  };
}
